// extracted by mini-css-extract-plugin
export default {"header":"DeleteShowName_header__MJMr2","icon":"DeleteShowName_icon__TQTDD"};